var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"popup-demo"}},[_c('popup-default'),_c('popup-inner-popup'),_c('popup-fullscreen'),_c('popup-background')],1)}
var staticRenderFns = []

export { render, staticRenderFns }